import { PlaceActionType } from './place-action-type';

export interface UpdatePlaceRequestAction {
  placeKey: string;
  type: PlaceActionType.UpdatePlaceRequest;
}

export const updatePlaceRequest = (
  placeKey: string,
): UpdatePlaceRequestAction => ({
  placeKey,
  type: PlaceActionType.UpdatePlaceRequest,
});
